import { useChargeDetailVM } from "presentation/hook/ChargeDetailMaintenance/useChargeDetailVM";
import { ChargeDetailModel } from "presentation/model/ChargeDetailMaintenance/ChargeDetailModel";
import { useEffect, useMemo, useState } from "react";
import { Accordion } from "veronica-ui-component/dist/component/core";
import { AccountTerminalAccordion } from "./AccountTerminalAccordion";
import { AdjustmentAccordion } from "./AdjustmentAccordion";
import { BillingTypeAccordion } from "./BillingTypeAccordion";
import { CntrSizeTypeAccordion } from "./CntrSizeTypeAccordion";
import { CompanyAccordion } from "./CompanyAccordion";
import { CopyCommonAcAccordion } from "./CopyCommonAcAccordion";
import { DgDuContentAccordion } from "./DgDuContentAccordion";
import { DirectDischargeIndAccordion } from "./DirectDischargeIndAccordion";
import { EmptyIndAccordion } from "./EmptyIndAccordion";
import { EmptyQtyAccordion } from "./EmptyQtyAccordion";
import { FspAccordion } from "./FspAccordion";
import { IgnoreCntrStatusValidAccordion } from "./IgnoreCntrStatusValidAccordion";
import { ManualAdjAccordion } from "./ManualAdjAccordion";
import { ManualTsLegChargeIndAccordion } from "./ManualTsLegChargeIndAccordion";
import { MarshallingTypeAccordion } from "./MarshallingTypeAccordion";
import { OffStdMeasurementModeAccordion } from "./OffStdMeasurementModeAccordion";
import { OneOffRateAccordion } from "./OneOffRateAccordion";
import { OperatingTmlAccordion } from "./OperatingTmlAccordion";
import { PermitNumberAccordion } from "./PermitNumberAccordion";
import { PooPolPodFdAccordion } from "./PooPolPodFdAccordion";
import { RFInfoAccordion } from "./RFInfoAccordion";
import { RFTempAccordion } from "./RFTempAccordion";
import { SecondLegInfoAccordion } from "./SecondLegInfoAccordion";
import { SoNumberAccordion } from "./SoNumberAccordion";
import { SpecialHandlingCodeAccordion } from "./SpecialHandlingCodeAccordion";
import { SpecialIndForwarderRefAccordion } from "./SpecialIndForwarderRefAccordion";
import { TSVesselInfoAccordion } from "./TSVesselInfoAccordion";
import { VesselInfoAccordion } from "./VesselInfoAccordion";
import { VoltageAccordion } from "./VoltageAccordion";
import { WaiverNumberAccordion } from "./WaiverNumberAccordion";
import { ServiceCodeAccordion } from "./ServiceCodeAccordion";
import { FromToDateAccordion } from "./FromToDateAccordion";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { ChangeQtyUomAccordion } from "./ChangeQtyUomAccordion";
import { ExciseCashCashReceiptNoAccordion } from "./ExciseCashCashReceiptNoAccordion";
import { TelexNoAccordion } from "./TelexNoAccordion";
import { RehandlingCancelShipmentTypeAccordion } from "./RehandlingCancelShipmentTypeAccordion";
import { ImcoGrossWtAccordion } from "./ImcoGrossWtAccordion";
import { RecevalCutoffTimeAccordion } from "./RecevalCutoffTimeAccordion";
import { CargoCodeAccordion } from "./CargoCodeAccordion";
import { ManualAssignTarCodeAccordion } from "./ManualAssignTarCodeAccordion";
import { UptDtlAdditionAccordion } from "./UptDtlAdditionAccordion";
import { EquipmentCodeAccordion } from "./EquipmentCodeAccordion";
import { ForwardCodeAccordion } from "./ForwardCodeAccordion";
import { ReferenceAccordion } from "./ReferenceAccordion";

export const AccordionPanel = ({ chargeDetailState }: { chargeDetailState: ChargeDetailModel }) => {
    const chargeDetailVM = useChargeDetailVM();
    const chargeBatchUpdate = chargeDetailState.chargeBatchUpdate;
    const [currentAccordionData, setCurrentAccordionData] = useState<any[]>();
    //disable the panel which show by their owner button click
    let tempChargeBatchUpdate = ({
        ...chargeBatchUpdate,
        // accResumeTerminalEnable: false,
        // oneOffRateEnable: false,
        // uptAbsolutelyCommonAcEnable: false,
        // copyCommonAcEnable: false,
        // adjustmentEnable: false,
    });
    const [anainfoState] = useANAInfoTracked();
    const { operatingUnit } = anainfoState;

    const handleAccordionChange = (e: boolean, i: number) => {
        if (currentAccordionData) {
            const key = currentAccordionData.at(i)?.key;
            chargeDetailVM.onAccordionPanelChange(e, chargeBatchUpdate, key);
        }
    };

    const accordionData = useMemo(() => {
        const accordionData = []

        if (tempChargeBatchUpdate.billToCompanyEnable || tempChargeBatchUpdate.chargeOnCompanyEnable
            // || tempChargeBatchUpdate.alterableBillToCompanyEnable || tempChargeBatchUpdate.alterableChargeOnCompanyEnable

        ) {
            accordionData.push({
                id: 'bill-to/charge-on company',
                header: 'Bill-To/Charge-On Company Code',
                content: <CompanyAccordion chargeDetailState={chargeDetailState} />,
                enableToggle: tempChargeBatchUpdate.billToCompanyActive ?? false,
                key: "billToCompanyActive",
                helpIcon: true,
                toolTipText: "Not applicable to 'EMP'.",
            })
        }
        if (tempChargeBatchUpdate.forwarderCode1Enable) {
            accordionData.push({
                id: 'upt forwarderCode1',
                header: 'Forwarder/Shipper/Consignee',
                content: <ForwardCodeAccordion chargeDetailState={chargeDetailState} />,
                enableToggle: tempChargeBatchUpdate.forwarderCode1Active ?? false,
                key: "forwarderCode1Active",
                helpIcon: true,
                toolTipText: "Not applicable to 'HDL','SVR_ODR','NP_ODR','RADIATION','XRAY'.",
            })
        }
        if (tempChargeBatchUpdate.accResumeTerminalEnable) {
            accordionData.push({
                id: 'account terminal',
                header: 'Account Terminal',
                content: <AccountTerminalAccordion chargeDetailState={chargeDetailState} />,
                enableToggle: tempChargeBatchUpdate.accResumeTerminalActive ?? false,
                key: "accResumeTerminalActive",
                helpIcon: true,
                toolTipText: "Not applicable to 'CC','DEM','COD','COV','DOC'.",
            })
        }
        if (tempChargeBatchUpdate.sizeEnable || tempChargeBatchUpdate.cntrTypeEnable) {
            accordionData.push({
                id: 'cntr size/type',
                header: 'Update Size/Type',
                content: <CntrSizeTypeAccordion chargeDetailState={chargeDetailState} />,
                enableToggle: tempChargeBatchUpdate.sizeActive ?? false,
                key: "sizeActive",
                helpIcon: true,
                toolTipText: "Not applicable to 'EMP','CY-Vesel Charge','AUC','VGM','CC','DEM','COD','COV','DOC'.",
            })
        }
        // if (tempChargeBatchUpdate.billingTypeEnable) {
        //     accordionData.push({
        //         id: 'billing type',
        //         header: 'Update Billing Type',
        //         content: <BillingTypeAccordion chargeDetailState={chargeDetailState} />,
        //         enableToggle: tempChargeBatchUpdate.billingTypeActive ?? false,
        //         key: "billingTypeActive",
        //     })
        // }
        if (tempChargeBatchUpdate.pooEnable || tempChargeBatchUpdate.polEnable || tempChargeBatchUpdate.podEnable || tempChargeBatchUpdate.fdEnable) {
            accordionData.push({
                id: 'Poo Pol Pod Fd',
                header: 'Update Poo Pol Pod Fd',
                content: <PooPolPodFdAccordion chargeDetailState={chargeDetailState} />,
                enableToggle: tempChargeBatchUpdate.pooActive ?? false,
                key: "pooActive",
                helpIcon: true,
                toolTipText: "Applicable to 'CY','RADIATION','XRAY','CFS'.",
            })
        }
        // if (tempChargeBatchUpdate.emptyIndEnable) {
        //     accordionData.push({
        //         id: 'empty indicator',
        //         header: 'Update Empty Indicator',
        //         content: <EmptyIndAccordion chargeDetailState={chargeDetailState} />,
        //         enableToggle: tempChargeBatchUpdate.emptyIndActive ?? false,
        //         key: "emptyIndActive",
        //     })
        // }
        if (tempChargeBatchUpdate.oneOffRateEnable) {
            accordionData.push({
                id: 'one-off Rate',
                header: 'Assign/Resume One-off Rate',
                content: <OneOffRateAccordion chargeDetailState={chargeDetailState} />,
                enableToggle: tempChargeBatchUpdate.oneOffRateActive ?? false,
                key: "oneOffRateActive",
                helpIcon: true,
                toolTipText: "Not applicable to 'EMP','CC','DEM','COD','COV','DOC','AUC','VGM'.",
            })
        }
        if (tempChargeBatchUpdate.operatingTmlEnable) {
            accordionData.push({
                id: 'operating tml',
                header: 'Update Operating Tml',
                content: <OperatingTmlAccordion chargeDetailState={chargeDetailState} />,
                enableToggle: tempChargeBatchUpdate.operatingTmlActive ?? false,
                key: "operatingTmlActive",
                helpIcon: true,
                toolTipText: "Not applicable to 'EMP','CY-Vesel Charge','GI','T3','CC','DEM','COD','COV','DOC','NP_ODR'.",
            })
        }
        // if (tempChargeBatchUpdate.manualTsLegChargeIndEnable) {
        //     accordionData.push({
        //         id: 'Manual TS Leg Charge Ind.',
        //         header: 'Assign Manual TS Leg Charge Ind. / Resume',
        //         content: <ManualTsLegChargeIndAccordion chargeDetailState={chargeDetailState} />,
        //         enableToggle: tempChargeBatchUpdate.manualTsLegChargeIndActive ?? false,
        //         key: "manualTsLegChargeIndActive",
        //         helpIcon: true,
        //         toolTipText: "Applicable to 'CY'.",
        //     })
        // }
        // if (tempChargeBatchUpdate.ignoreCntrStatusValidEnable) {
        //     accordionData.push({
        //         id: 'Ignore Cont. Status Validation',
        //         header: 'Ignore Cont. Status Validation',
        //         content: <IgnoreCntrStatusValidAccordion chargeDetailState={chargeDetailState} />,
        //         enableToggle: tempChargeBatchUpdate.ignoreCntrStatusValidActive ?? false,
        //         key: "ignoreCntrStatusValidActive",
        //     })
        // }
        if (tempChargeBatchUpdate.dgContentEnable) {
            accordionData.push({
                id: 'DG DU Content',
                header: 'Update DG/DU Content',
                content: <DgDuContentAccordion chargeDetailState={chargeDetailState} />,
                enableToggle: tempChargeBatchUpdate.dgContentActive ?? false,
                key: "dgContentActive",
                helpIcon: true,
                toolTipText: "Applicable to 'ITM','OBS','TSS','MAR','YH','CY','General Charge','COS','CSR','CC','DEM','COD','COV','DOC'.",
            })
        }
        if (tempChargeBatchUpdate.specialIndEnable) {
            accordionData.push({
                id: 'Special Ind/Forwarder Ref',
                header: 'Update Special Ind/Forwarder Reference',
                content: <SpecialIndForwarderRefAccordion chargeDetailState={chargeDetailState} />,
                enableToggle: tempChargeBatchUpdate.specialIndtActive ?? false,
                key: "specialIndtActive",
                helpIcon: true,
                toolTipText: "Not applicable to 'T3','RAIL','SVR_ODR','EXM','GI','NP_ODR'.",
            })
        }
        if (tempChargeBatchUpdate.rfTempEnable) {
            accordionData.push({
                id: 'RF Temp.',
                header: 'Update RF Temp./Unit',
                content: <RFTempAccordion chargeDetailState={chargeDetailState} />,
                enableToggle: tempChargeBatchUpdate.rfTempActive ?? false,
                key: "rfTempActive",
                helpIcon: true,
                toolTipText: "Applicable to 'ITM','OBS','TSS','MAR','YH','CY','General Charge','COS','CSR','CC','DEM','COD','COV','DOC'.",
            })
        }
        if (tempChargeBatchUpdate.manualAdjEnable) {
            accordionData.push({
                id: 'manual Adj Charge',
                header: 'Manual Adjustment Charge',
                content: <ManualAdjAccordion chargeDetailState={chargeDetailState} />,
                enableToggle: tempChargeBatchUpdate.manualAdjActive ?? false,
                key: "manualAdjActive",
                helpIcon: true,
                toolTipText: "Applicable to 'ITM','GS','OBS','TSS','DEL','RFH','CC','DEM','COD','COV','DOC'.",
            })
        }
        if (tempChargeBatchUpdate.soNumberEnable) {
            accordionData.push({
                id: 'so number',
                header: 'Update So Number',
                content: <SoNumberAccordion chargeDetailState={chargeDetailState} />,
                enableToggle: tempChargeBatchUpdate.soNumberActive ?? false,
                key: "soNumberActive",
                helpIcon: true,
                toolTipText: "Applicable to 'CY','YH','ITM','GS','OBS','MAR','COS','CSR'.",
            })
        }
        if (tempChargeBatchUpdate.uptQtyEnable) {
            accordionData.push({
                id: 'upt charge qty/uom',
                header: 'Update Charge Qty/Uom',
                content: <ChangeQtyUomAccordion chargeDetailState={chargeDetailState} />,
                enableToggle: tempChargeBatchUpdate.uptQtyActive ?? false,
                key: "uptQtyActive",
                helpIcon: true,
                toolTipText: ("SAPT" === operatingUnit || "KICT" === operatingUnit) ? "Applicable to 'CSR','NP_ODR'." : "Applicable to 'CSR','CC','DEM','COD','COV','DOC','NP_ODR','CFS'.",
            })
        }
        if (tempChargeBatchUpdate.exciseCashNoEnable) {
            accordionData.push({
                id: 'upt excise cash/cash receipt no',
                header: 'Update Excise Cash/Cash Receipt No.',
                content: <ExciseCashCashReceiptNoAccordion chargeDetailState={chargeDetailState} />,
                enableToggle: tempChargeBatchUpdate.exciseCashNoActive ?? false,
                key: "exciseCashNoActive",
                helpIcon: true,
                toolTipText: "Applicable to 'CC','DEM','COD','COV','DOC'.",
            })
        }
        // if (tempChargeBatchUpdate.copyCommonAcEnable) {
        //     accordionData.push({
        //         id: 'Copy Cm A/C To',
        //         header: 'Copy Cm A/C To',
        //         content: <CopyCommonAcAccordion chargeDetailState={chargeDetailState} />,
        //         enableToggle: tempChargeBatchUpdate.copyCommonAcActive ?? false,
        //         key: "copyCommonAcActive",
        //     })
        // }
        if (tempChargeBatchUpdate.adjustmentEnable) {
            accordionData.push({
                id: 'adjustment',
                header: 'Adjustment',
                content: <AdjustmentAccordion chargeDetailState={chargeDetailState} />,
                enableToggle: tempChargeBatchUpdate.adjustmentActive ?? false,
                key: "adjustmentActive",
            })
        }
        if (tempChargeBatchUpdate.waiverNoEnable) {
            accordionData.push({
                id: 'waiverNo',
                header: 'Waiver No.',
                content: <WaiverNumberAccordion chargeDetailState={chargeDetailState} />,
                enableToggle: tempChargeBatchUpdate.waiverNoActive ?? false,
                key: "waiverNoActive",
                helpIcon: true,
                toolTipText: "Applicable to 'TSS','OBS','General Charge','COS'.",
            })
        }
        if (tempChargeBatchUpdate.dischargeIndEnable) {
            accordionData.push({
                id: 'directDischargeInd',
                header: 'Direct/Indirect Discharge Ind.',
                content: <DirectDischargeIndAccordion chargeDetailState={chargeDetailState} />,
                enableToggle: tempChargeBatchUpdate.dischargeIndActive ?? false,
                key: "dischargeIndActive",
                helpIcon: true,
                toolTipText: "Applicable to 'CY','General Charge','OBS','TSS','COS','CC','DEM','COD','COV','DOC'.",
            })
        }
        // if (tempChargeBatchUpdate.seclegDischargeIndEnable || tempChargeBatchUpdate.seclegOperatingTmlEnable || tempChargeBatchUpdate.seclegSpecialIndEnable) {
        //     accordionData.push({
        //         id: 'secLegInfo',
        //         header: 'Update 2nd Leg Info',
        //         content: <SecondLegInfoAccordion chargeDetailState={chargeDetailState} />,
        //         enableToggle: tempChargeBatchUpdate.seclegSpecialIndActive ?? false,
        //         key: "seclegSpecialIndActive",
        //     })
        // }
        if (tempChargeBatchUpdate.permitNoEnable) {
            accordionData.push({
                id: 'permitNo',
                header: 'Update Permit No.',
                content: <PermitNumberAccordion chargeDetailState={chargeDetailState} />,
                enableToggle: tempChargeBatchUpdate.permitNoActive ?? false,
                key: "permitNoActive",
                helpIcon: true,
                toolTipText: "Applicable to 'CY','General Charge','OBS','TSS','CSR','CC','DEM','COD','COV','DOC'.",
            })
        }
        if (tempChargeBatchUpdate.rfInfoEnable) {
            accordionData.push({
                id: 'refeerContainerInfo',
                header: 'Refeer Container Info',
                content: <RFInfoAccordion chargeDetailState={chargeDetailState} />,
                enableToggle: tempChargeBatchUpdate.rfInfoActive ?? false,
                key: "rfInfoActive",
                helpIcon: true,
                toolTipText: "Applicable to 'RFH'.",
            })
        }
        if (tempChargeBatchUpdate.emptyChargeQtyEnable) {
            accordionData.push({
                id: 'emptyChargeQty',
                header: 'Empty Charge Qty',
                content: <EmptyQtyAccordion chargeDetailState={chargeDetailState} />,
                enableToggle: tempChargeBatchUpdate.emptyChargeQtyActive ?? false,
                key: "emptyChargeQtyActive",
                helpIcon: true,
                toolTipText: "Applicable to 'EMP'.",
            })
        }
        // if (tempChargeBatchUpdate.tierFspEnable) {
        //     accordionData.push({
        //         id: 'tierFspEnable',
        //         header: 'Update FSP',
        //         content: <FspAccordion chargeDetailState={chargeDetailState} />,
        //         enableToggle: tempChargeBatchUpdate.tierFspActive ?? false,
        //         key: "tierFspActive",
        //     })
        // }
        if (tempChargeBatchUpdate.voltageEnable) {
            accordionData.push({
                id: 'voltageEnable',
                header: 'Update Voltage',
                content: <VoltageAccordion chargeDetailState={chargeDetailState} />,
                enableToggle: tempChargeBatchUpdate.voltageActive ?? false,
                key: "voltageActive",
                helpIcon: true,
                toolTipText: "Applicable to 'CY'.",
            })
        }
        if (tempChargeBatchUpdate.offStdMeasurementModeEnable) {
            accordionData.push({
                id: 'offStdMeasurementModeEnable',
                header: 'Update Off Std Measurement Mode',
                content: <OffStdMeasurementModeAccordion chargeDetailState={chargeDetailState} />,
                enableToggle: tempChargeBatchUpdate.offStdMeasurementModeActive ?? false,
                key: "offStdMeasurementModeActive",
                helpIcon: true,
                toolTipText: "Applicable to 'General Charge'.",
            })
        }
        if (tempChargeBatchUpdate.marshallingTypeEnable) {
            accordionData.push({
                id: 'marshallingTypeEnable',
                header: 'Update Marshalling Type',
                content: <MarshallingTypeAccordion chargeDetailState={chargeDetailState} />,
                enableToggle: tempChargeBatchUpdate.marshallingTypeActive ?? false,
                key: "marshallingTypeActive",
                helpIcon: true,
                toolTipText: "Applicable to 'MAR'.",
            })
        }
        if (tempChargeBatchUpdate.specialHandlingCodeEnable) {
            accordionData.push({
                id: 'specialHandlingCodeEnable',
                header: 'Update Special Handling Code (D1)',
                content: <SpecialHandlingCodeAccordion chargeDetailState={chargeDetailState} />,
                enableToggle: tempChargeBatchUpdate.specialHandlingCodeActive ?? false,
                key: "specialHandlingCodeActive",
                helpIcon: true,
                toolTipText: "Applicable to 'CSR','CC','DEM','COD','COV','DOC'.",
            })
        }
        if (tempChargeBatchUpdate.vesselInfoEnable) {
            accordionData.push({
                id: 'vesselInfoEnable',
                header: 'Update Vessel Info',
                content: <VesselInfoAccordion chargeDetailState={chargeDetailState} />,
                enableToggle: tempChargeBatchUpdate.vesselInfoActive ?? false,
                key: "vesselInfoActive",
                helpIcon: true,
                toolTipText: "Applicable to 'CY','CY-Vesel Charge','TSS','GS','RFH','COO','HPI','HOL','CODCOV','CSR','RFH'.",
            })
        }
        if (tempChargeBatchUpdate.tsVesselInfoEnable) {
            accordionData.push({
                id: 'tsVesselInfoEnable',
                header: 'Update TS Vessel Info',
                content: <TSVesselInfoAccordion chargeDetailState={chargeDetailState} />,
                enableToggle: tempChargeBatchUpdate.tsVesselInfoActive ?? false,
                key: "tsVesselInfoActive",
                helpIcon: true,
                toolTipText: "Applicable to 'TSS'.",
            })
        }
        if (tempChargeBatchUpdate.serviceCodeEnable) {
            accordionData.push({
                id: 'serviceCodeEnable',
                header: 'Update Service Code',
                content: <ServiceCodeAccordion chargeDetailState={chargeDetailState} />,
                enableToggle: tempChargeBatchUpdate.serviceCodeActive ?? false,
                key: "serviceCodeActive",
                helpIcon: true,
                toolTipText: "Applicable to 'MAR','HPI','HOL','COO','COS','CSR'.",
            })
        }
        if (tempChargeBatchUpdate.fromToDateEnable) {
            accordionData.push({
                id: 'fromToDateEnable',
                header: 'Update From Date/To Date',
                content: <FromToDateAccordion chargeDetailState={chargeDetailState} />,
                enableToggle: tempChargeBatchUpdate.fromToDateActive ?? false,
                key: "fromToDateActive",
                helpIcon: true,
                toolTipText: "Applicable to 'CSR' and not applicable to 'CSR-TC'.",
            })
        }
        if (tempChargeBatchUpdate.telexNoEnable) {
            accordionData.push({
                id: 'upt telex no',
                header: 'Update Telex No',
                content: <TelexNoAccordion chargeDetailState={chargeDetailState} />,
                enableToggle: tempChargeBatchUpdate.telexNoActive ?? false,
                key: "telexNoActive",
                helpIcon: true,
                toolTipText: "Applicable to 'HPV','HPI','HOL','CODCOV','COS'.",
            })
        }
        if (tempChargeBatchUpdate.rehandlingCancelshipmentTypeEnable) {
            accordionData.push({
                id: 'upt rc type',
                header: 'Update Rehandling/Cancel Shipment Type',
                content: <RehandlingCancelShipmentTypeAccordion chargeDetailState={chargeDetailState} />,
                enableToggle: tempChargeBatchUpdate.rehandlingCancelshipmentTypeActive ?? false,
                key: "rehandlingCancelshipmentTypeActive",
                helpIcon: true,
                toolTipText: "Applicable to 'CSR','CC','DEM','COD','COV','DOC'.",
            })
        }
        if (tempChargeBatchUpdate.equipmentCodeEnable) {
            accordionData.push({
                id: 'upt equipmentCode',
                header: 'Update Equipment Code',
                content: <EquipmentCodeAccordion chargeDetailState={chargeDetailState} />,
                enableToggle: tempChargeBatchUpdate.equipmentCodeActive ?? false,
                key: "equipmentCodeActive",
                helpIcon: true,
                toolTipText: "Applicable to 'CY','YH','TSS','COS','GS','ITM','General Charge'.",
            })
        }
        if (tempChargeBatchUpdate.imcoEnable || tempChargeBatchUpdate.grossWtEnable) {
            accordionData.push({
                id: 'upt imco/grossWt',
                header: 'Update Imco/Gross Wt.',
                content: <ImcoGrossWtAccordion chargeDetailState={chargeDetailState} />,
                enableToggle: (tempChargeBatchUpdate.imcoActive || tempChargeBatchUpdate.grossWtActive) ?? false,
                key: tempChargeBatchUpdate.imcoEnable ? "imcoActive" : "grossWtActive",
                helpIcon: true,
                toolTipText: "Applicable to 'CY','RFH','MAR'.",
            })
        }
        if (tempChargeBatchUpdate.recevalCutoffTimeEnable) {
            accordionData.push({
                id: 'upt recevalCutoffTime',
                header: 'Update Receval Cutoff Time',
                content: <RecevalCutoffTimeAccordion chargeDetailState={chargeDetailState} />,
                enableToggle: tempChargeBatchUpdate.recevalCutoffTimeActive ?? false,
                key: "recevalCutoffTimeActive",
                helpIcon: true,
                toolTipText: "Applicable to 'CC','DEM','COD','COV','DOC','OBS'.",
            })
        }
        if (tempChargeBatchUpdate.cargoCodeEnable) {
            accordionData.push({
                id: 'upt recevalCutoffTime',
                header: 'Update Cargo Code',
                content: <CargoCodeAccordion chargeDetailState={chargeDetailState} />,
                enableToggle: tempChargeBatchUpdate.cargoCodeActive ?? false,
                key: "cargoCodeActive",
                helpIcon: true,
                toolTipText: "Applicable to 'CY','ITM','OBS','GS','RFH','CC','DEM','COD','COV','DOC'.",
            })
        }

        if (tempChargeBatchUpdate.manAssignTarCodeEnable) {
            accordionData.push({
                id: 'upt manualAssignTarCode',
                header: 'Update Manual Assign Tariff Code',
                content: <ManualAssignTarCodeAccordion chargeDetailState={chargeDetailState} />,
                enableToggle: tempChargeBatchUpdate.manAssignTarCodeActive ?? false,
                key: "manAssignTarCodeActive",
                helpIcon: true,
                toolTipText: "Applicable to 'CFS'.",
            })
        }

        if (tempChargeBatchUpdate.dtlAdditionFieldEnable) {
            accordionData.push({
                id: 'upt dtlAdditionField',
                header: 'Update Dtl Addition Field',
                content: <UptDtlAdditionAccordion chargeDetailState={chargeDetailState} />,
                enableToggle: tempChargeBatchUpdate.dtlAdditionFieldActive ?? false,
                key: "dtlAdditionFieldActive",
                helpIcon: true,
                toolTipText: "Applicable to 'CFS','DEL','HDL'.",
            })
        }

        if (tempChargeBatchUpdate.referenceEnable) {
            accordionData.push({
                id: 'upt reference',
                header: 'Update Reference',
                content: <ReferenceAccordion chargeDetailState={chargeDetailState} />,
                enableToggle: tempChargeBatchUpdate.referenceActive ?? false,
                key: "referenceActive",
                helpIcon: true,
                toolTipText: "Applicable to 'CY'.",
            })
        }

        return accordionData
    }, [tempChargeBatchUpdate.billToCompanyEnable, tempChargeBatchUpdate.chargeOnCompanyEnable, tempChargeBatchUpdate.forwarderCode1Enable, tempChargeBatchUpdate.accResumeTerminalEnable, tempChargeBatchUpdate.sizeEnable, tempChargeBatchUpdate.cntrTypeEnable, tempChargeBatchUpdate.pooEnable, tempChargeBatchUpdate.polEnable, tempChargeBatchUpdate.podEnable, tempChargeBatchUpdate.fdEnable, tempChargeBatchUpdate.oneOffRateEnable, tempChargeBatchUpdate.operatingTmlEnable, tempChargeBatchUpdate.dgContentEnable, tempChargeBatchUpdate.specialIndEnable, tempChargeBatchUpdate.rfTempEnable, tempChargeBatchUpdate.manualAdjEnable, tempChargeBatchUpdate.soNumberEnable, tempChargeBatchUpdate.uptQtyEnable, tempChargeBatchUpdate.exciseCashNoEnable, tempChargeBatchUpdate.adjustmentEnable, tempChargeBatchUpdate.waiverNoEnable, tempChargeBatchUpdate.dischargeIndEnable, tempChargeBatchUpdate.permitNoEnable, tempChargeBatchUpdate.rfInfoEnable, tempChargeBatchUpdate.emptyChargeQtyEnable, tempChargeBatchUpdate.voltageEnable, tempChargeBatchUpdate.offStdMeasurementModeEnable, tempChargeBatchUpdate.marshallingTypeEnable, tempChargeBatchUpdate.specialHandlingCodeEnable, tempChargeBatchUpdate.vesselInfoEnable, tempChargeBatchUpdate.tsVesselInfoEnable, tempChargeBatchUpdate.serviceCodeEnable, tempChargeBatchUpdate.fromToDateEnable, tempChargeBatchUpdate.telexNoEnable, tempChargeBatchUpdate.rehandlingCancelshipmentTypeEnable, tempChargeBatchUpdate.equipmentCodeEnable, tempChargeBatchUpdate.imcoEnable, tempChargeBatchUpdate.grossWtEnable, tempChargeBatchUpdate.recevalCutoffTimeEnable, tempChargeBatchUpdate.cargoCodeEnable, tempChargeBatchUpdate.manAssignTarCodeEnable, tempChargeBatchUpdate.dtlAdditionFieldEnable, tempChargeBatchUpdate.referenceEnable, tempChargeBatchUpdate.billToCompanyActive, tempChargeBatchUpdate.forwarderCode1Active, tempChargeBatchUpdate.accResumeTerminalActive, tempChargeBatchUpdate.sizeActive, tempChargeBatchUpdate.pooActive, tempChargeBatchUpdate.oneOffRateActive, tempChargeBatchUpdate.operatingTmlActive, tempChargeBatchUpdate.dgContentActive, tempChargeBatchUpdate.specialIndtActive, tempChargeBatchUpdate.rfTempActive, tempChargeBatchUpdate.manualAdjActive, tempChargeBatchUpdate.soNumberActive, tempChargeBatchUpdate.uptQtyActive, tempChargeBatchUpdate.exciseCashNoActive, tempChargeBatchUpdate.adjustmentActive, tempChargeBatchUpdate.waiverNoActive, tempChargeBatchUpdate.dischargeIndActive, tempChargeBatchUpdate.permitNoActive, tempChargeBatchUpdate.rfInfoActive, tempChargeBatchUpdate.emptyChargeQtyActive, tempChargeBatchUpdate.voltageActive, tempChargeBatchUpdate.offStdMeasurementModeActive, tempChargeBatchUpdate.marshallingTypeActive, tempChargeBatchUpdate.specialHandlingCodeActive, tempChargeBatchUpdate.vesselInfoActive, tempChargeBatchUpdate.tsVesselInfoActive, tempChargeBatchUpdate.serviceCodeActive, tempChargeBatchUpdate.fromToDateActive, tempChargeBatchUpdate.telexNoActive, tempChargeBatchUpdate.rehandlingCancelshipmentTypeActive, tempChargeBatchUpdate.equipmentCodeActive, tempChargeBatchUpdate.imcoActive, tempChargeBatchUpdate.grossWtActive, tempChargeBatchUpdate.recevalCutoffTimeActive, tempChargeBatchUpdate.cargoCodeActive, tempChargeBatchUpdate.manAssignTarCodeActive, tempChargeBatchUpdate.dtlAdditionFieldActive, tempChargeBatchUpdate.referenceActive, chargeDetailState, operatingUnit]
    );

    useEffect(() => {
        setCurrentAccordionData(accordionData);
    }, [accordionData])

    return (
        <div className='flex-row-item flex-row-item-full-width'>
            <Accordion accordionData={accordionData} width="450px" toggle onChange={(e, activeIndex) => { handleAccordionChange(e, activeIndex) }} />
        </div>
    )
}